import styled from '@emotion/styled';

const Wrapper = styled.div`
  min-height: 450px;
`;

export default { Wrapper };
